import type { MiniAppAuthTokenRequest, MiniAppAuthTokenResponse } from './types';

// Бэкенд ходит в Telegram за токеном, поэтому запрос небыстрый, но зависать он не должен:
// пока он не завершится, вся авторизация приложения заблокирована.
const REQUEST_TIMEOUT_MS = 20000;

/**
 * Получить tgWebAuthToken от бэкенда Mini App.
 * Использует initData от Telegram для аутентификации запроса.
 */
export async function fetchMiniAppAuthToken({
  accountId,
  initData,
  backendUrl,
}: MiniAppAuthTokenRequest): Promise<MiniAppAuthTokenResponse | undefined> {
  const abortController = new AbortController();
  const timeoutId = self.setTimeout(() => abortController.abort(), REQUEST_TIMEOUT_MS);

  try {
    const response = await fetch(`${backendUrl}/accounts/${accountId}/web-token`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${initData}`,
      },
      signal: abortController.signal,
    });

    if (!response.ok) {
      console.error(
        '[fetchMiniAppAuthToken] Backend error:',
        response.status,
        response.statusText,
      );
      return undefined;
    }

    const data = await response.json();

    if (!data.tgWebAuthToken) {
      console.error('[fetchMiniAppAuthToken] Missing tgWebAuthToken in response');
      return undefined;
    }

    return {
      token: data.tgWebAuthToken,
      userId: data.tgWebAuthUserId,
      dcId: data.tgWebAuthDcId ? Number(data.tgWebAuthDcId) : undefined,
    };
  } catch (err) {
    console.error('[fetchMiniAppAuthToken] Request failed:', err);
    return undefined;
  } finally {
    self.clearTimeout(timeoutId);
  }
}
